import { Role } from '@/router/enum';
import { RouteRecordRaw } from 'vue-router';
import { FirmwarePermission } from '@/api/request/forklift/enum';

export const forkliftFirmwareRoute: RouteRecordRaw = {
  path: 'forklift',
  name: 'forklift',
  meta: {
    title: '叉车固件',
    key: 'firmware',
    icon: 'ClusterOutlined',
    permission: [Role.ADMIN, Role.USER],
  },
  children: [
    {
      path: 'forklift-publish-overview',
      name: 'forklift-publish-overview',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/overview/overview-page.vue'
        ),
      meta: {
        title: '固件总览',
        key: 'forklift-publish-overview',
        icon: 'appstore-outlined',
        permission: [Role.ADMIN, Role.USER, Role.FORKLIFT_USER],
      },
    },
    {
      path: 'forklift-publish',
      name: 'forklift-publish',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/hardware/forklift-hardware.vue'
        ),
      meta: {
        title: '固件列表',
        key: 'forklift-publish',
        icon: 'cloud-upload-outlined',
        permission: [Role.ADMIN, Role.USER, Role.FORKLIFT_USER],
      },
    },
    {
      path: 'forklift-customer-map',
      name: 'forklift-customer-map',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/customer-map/forklift-customer-map.vue'
        ),
      meta: {
        title: '客户图号维护',
        key: 'forklift-customer-map',
        icon: 'ApartmentOutlined',
        permission: [Role.ADMIN, Role.FORKLIFT_ADMIN],
      },
    },
    {
      path: 'forklift-publish-detail',
      name: 'forklift-publish-detail',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-firmware-detail.vue'
        ),
      meta: {
        title: '固件列表',
        key: 'forklift-publish-detail',
        icon: 'cloud-upload-outlined',
        inside: true,
        permission: [Role.ADMIN, Role.USER, Role.FORKLIFT_USER],
      },
    },
    {
      path: 'forklift-publish-draft',
      name: 'forklift-publish-draft',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-firmware-draft.vue'
        ),
      meta: {
        title: '草稿箱',
        key: 'forklift-publish-draft',
        icon: 'file-text-outlined',
        inside: true,
        permission: [Role.ADMIN, Role.USER],
      },
    },
    {
      path: 'forklift-map-code-detail',
      name: 'forklift-map-code-detail',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-map-code-detail.vue'
        ),
      meta: {
        title: '图号列表',
        key: 'forklift-map-code-detail',
        icon: 'cloud-upload-outlined',
        inside: true,
        permission: [Role.ADMIN, Role.USER, Role.FORKLIFT_USER],
      },
    },
    {
      path: 'forklift-map-code-import',
      name: 'forklift-map-code-import',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-map-code-import.vue'
        ),
      meta: {
        title: 'Excel 导入图号',
        key: 'forklift-map-code-import',
        icon: 'cloud-upload-outlined',
        inside: true,
        permission: [Role.ADMIN, Role.USER, Role.FORKLIFT_USER],
      },
    },
    {
      path: 'forklift-pending-audit',
      name: 'forklift-pending-audit',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-pending-audit.vue'
        ),
      meta: {
        title: '我的待审',
        key: 'forklift-pending-audit',
        icon: 'audit-outlined',
        // 菜单与路由按 IAM 权限隐藏：固件审核 或 测试中心审核（OR）
        iamPermission: [
          FirmwarePermission.AUDITOR,
          FirmwarePermission.TEST_CENTER,
        ],
        permission: [Role.ADMIN, Role.USER],
      },
    },
    {
      path: 'forklift-retest',
      name: 'forklift-retest',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/firmware/forklift-retest.vue'
        ),
      meta: {
        title: '补测任务',
        key: 'forklift-retest',
        icon: 'experiment-outlined',
        // 特殊发布补测闭环（补测确认 + 补测清单），仅测试中心可见
        iamPermission: [FirmwarePermission.TEST_CENTER],
        permission: [Role.ADMIN, Role.USER],
      },
    },
    {
      path: 'forklift-driver',
      name: 'forklift-driver',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/driver/forklift-driver.vue'
        ),
      meta: {
        title: '驱动备份',
        key: 'forklift-driver',
        icon: 'PicCenterOutlined',
        permission: [Role.ADMIN, Role.USER],
      },
    },
    {
      path: 'forklift-user',
      name: 'forklift-user',
      component: () =>
        import(
          '@/views/back-stage-management/Firmware/forklift/user/forklift-user.vue'
        ),
      meta: {
        title: '用户管理',
        key: 'forklift-user',
        icon: 'UserOutlined',
        permission: [Role.ADMIN, Role.FORKLIFT_ADMIN],
      },
    },
  ],
};
